import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles.css';
import Meta from 'vue-meta'

Vue.config.productionTip = false

new Vue({
  router,
  Meta,
  render: function (h) { return h(App) }
}).$mount('#app')
